import { render, staticRenderFns } from "./manage-phone-numbers.vue?vue&type=template&id=22a32f18&scoped=true"
import script from "./manage-phone-numbers.vue?vue&type=script&lang=js"
export * from "./manage-phone-numbers.vue?vue&type=script&lang=js"
import style0 from "./manage-phone-numbers.vue?vue&type=style&index=0&id=22a32f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a32f18",
  null
  
)

export default component.exports